import * as React from 'react';
import IMarketPage, { TMarketPageState } from './IMarketPage';
import { Route, Switch } from 'react-router';
import BuyTradePage from '../BuyTradePage/BuyTradePage';
import SellTradePage from '../SellTradePage/SellTradePage';
import BuyOrderPage from '../BuyOrderPage/BuyOrderPage';
import SellOrderPage from '../SellOrderPage/SellOrderPage';
import OrderPage from '@market/pages/OrderPage/OrderPage';

import * as style from './MarketPageStyle.module.scss'

class MarketPage extends React.Component<IMarketPage, TMarketPageState> {
  state: TMarketPageState = {};

  render() {
    const orderPageRoute = `/companies/:slug/market/spvs/:asset_id/orders`;
    const buyOrderRoute = `/companies/:slug/market/spvs/:asset_id/orders/buy`;
    const sellOrderRoute = `/companies/:slug/market/spvs/:asset_id/orders/sell`;
    const buyTradeRoute = `/companies/:slug/market/spvs/:asset_id/trades/buy/:order_id`;
    const sellTradeRoute = `/companies/:slug/market/spvs/:asset_id/trades/sell/:order_id`;

    return (
      <div className={style.container}>
        <Switch>
              <Route
                exact={true}
                path={orderPageRoute}
                render={(props: any) => (
                  <OrderPage
                    {...props}
                  />
                )}
              />
              <Route
                exact={true}
                path={buyOrderRoute}
                component={BuyOrderPage}
              />
              <Route
                exact={true}
                path={sellOrderRoute}
                component={SellOrderPage}

              />
              <Route
                exact={true}
                path={buyTradeRoute}
                component={BuyTradePage}
              />
              <Route
                exact={true}
                path={sellTradeRoute}
                component={SellTradePage}
              />
              {/*
                We have to redirect user with pure JS because <Redirect /> doesn't work in this case
                due to Market is registered as an external app
              */}
              <Route
                exact={true}
                render={() => <>{window.location.replace('/market/spvs')}</>}
              />
        </Switch>
      </div>
    );
  }
}

export default MarketPage;
